// @ts-nocheck TODO: fix types for the entire file

import styled from '@emotion/styled';
import { pxToEm } from 'theme';
import palette from 'theme/palette';
import { Typography } from '../../Typography';

interface FilterButtonsProps {
  ischild?: boolean;
  marginBottom?: number;
  isLong: boolean;
}

export const SwitchBox = styled.button<Partial<FilterButtonsProps>>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  background: none;
  border: 0;
  padding-bottom: ${({ marginBottom }) => pxToEm(marginBottom)};
  &:disabled {
    opacity: 0.6;
  }
  & .MuiCircularProgress-root {
    width: ${pxToEm(18)} !important;
    height: auto !important;
  }
`;

export const SwitchLabel = styled(Typography)`
  display: flex;
  align-items: center;
  gap: 4px;
  svg {
    width: 18px;
  }
`;

export const TooltipWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
`;

export const FilterAction = styled.div<{ isSelected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  height: 100%;
  width: ${pxToEm(22)};
  cursor: pointer;
  opacity: ${({ isSelected }) => (isSelected ? '1' : '0.5')};
`;

export const FilterLabel = styled.span<Partial<FilterButtonsProps>>`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: ${pxToEm(12)};
  overflow: hidden;
  text-overflow: ellipsis;
  .filterName {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const FilterLabelActions = styled.div`
  display: flex;
  align-items: center;
`;

export const ItemNumber = styled(Typography)`
  color: ${({ theme }) => theme.palette.grey['A400']} !important;
`;

export const FilterButton = styled.button<Partial<FilterButtonsProps>>`
  background: none;
  border: 0;
  display: flex;
  align-items: center;
  align-content: center;
  justify-content: flex-start;
  font-size: 16px;
  width: 100%;
  padding-left: 0;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: ${({ marginBottom }) => pxToEm(marginBottom)};
  cursor: pointer;
  margin-left: ${(props) => (props.ischild ? '28px' : '0')};
  & .MuiCircularProgress-root {
    width: ${pxToEm(18)} !important;
    height: auto !important;
  }
  &:disabled {
    opacity: 0.6;
  }
  &:hover {
    ${ItemNumber} {
      color: ${({ theme }) => theme.palette.primary.main} !important;
    }
    ${FilterAction} {
      opacity: 1;
    }
  }
`;

export const Badge = styled.div`
  background: ${palette.success.main};
  border-radius: ${pxToEm(15)};
  font-size: ${pxToEm(10)};
  font-weight: 600;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: ${pxToEm(24)};
  min-width: ${pxToEm(24)};
  padding: 0 ${pxToEm(6)};
  color: ${palette.common.white};
  margin-left: auto;
  margin-right: ${pxToEm(6)};
`;
